import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdminSettings = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 20,
	fill: "none",
	viewBox: "0 0 13 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8.38 7.98Q9.2 7.16 9.2 6t-.82-1.98A2.7 2.7 0 0 0 6.4 3.2q-1.16 0-1.98.82A2.7 2.7 0 0 0 3.6 6q0 1.16.82 1.98t1.98.82 1.98-.82M6.4 16q-2.92-.74-4.66-3.2T0 7.28V2.4L6.4 0l6.4 2.4v4.88q0 3.06-1.74 5.52T6.4 16m0-1.68a5.8 5.8 0 0 0 2.09-1.19 9.5 9.5 0 0 0 1.59-1.83 8.3 8.3 0 0 0-1.79-.67 7.85 7.85 0 0 0-3.78 0 8.3 8.3 0 0 0-1.79.67q.68 1.02 1.59 1.83t2.09 1.19" })
});
export { SvgAdminSettings as ReactComponent };
